import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Module Pages
import CVModulePage from './cv/CVModulePage';
import MongoDBModulePage from './mongodb/MongoDBModulePage';
import AirflowModulePage from './airflow/AirflowModulePage';
import ApiGatewayModulePage from './apigateway/ApiGatewayModulePage';
import ProjectLakehouseDataSources from './lakehouse/ProjectLakehouseDataSources';

/**
 * Router component for workspace storage modules
 * Routes:
 * - /workspace/storage/:projectId/lakehouse  (Big Data / 4 nguồn: MongoDB, Postgres, MinIO, Firebase)
 * - /workspace/storage/:projectId/cv
 * - /workspace/storage/:projectId/mongodb
 * - /workspace/storage/:projectId/airflow
 * - /workspace/storage/:projectId/api-gateway
 */
const WorkspaceStorageRouter = ({ module }) => {
    const { projectId } = useParams();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/workspace/storage');
    };

    // Get project subname from URL query or state
    const searchParams = new URLSearchParams(window.location.search);
    const projectSubname = searchParams.get('subname') || '';

    switch (module) {
        case 'lakehouse':
            return (
                <ProjectLakehouseDataSources
                    projectName={projectId}
                    projectSubname={projectSubname}
                    onBack={handleBack}
                />
            );

        case 'cv':
            return <CVModulePage projectName={projectId} projectSubname={projectSubname} onBack={handleBack} />;

        case 'mongodb':
            return <MongoDBModulePage projectName={projectId} projectSubname={projectSubname} onBack={handleBack} />;

        case 'airflow':
            return <AirflowModulePage projectName={projectId} projectSubname={projectSubname} onBack={handleBack} />;

        case 'api-gateway':
            return <ApiGatewayModulePage projectName={projectId} projectSubname={projectSubname} onBack={handleBack} />;

        default:
            navigate('/workspace/storage');
            return null;
    }
};

export default WorkspaceStorageRouter;
